import { apiCall, baseUrl, exportFileCall } from './config';
import { shouldUseMock } from '../../utils/common';
import {
  getCourseActivitiesMock,
  getCourseStatsMock,
  getCourseUsersMock,
  getCourseUsersActivitiesMock,
  getGroupCoursesMock,
  getMyCoursesMock,
  getMyUsersMock,
  getUserCoursesMock,
  getUserGroupsMock,
  getUserListMock,
  getUserStatsMock,
  getCourseCreatedListMock,
  getSurveyStatsMock,
  getSurveyFreeTextMock,
  successMock,
} from './mock';
import { parseQueryParams } from '../../utils/queryParams';
import {
  activitySessionPath,
  authPath,
  coursePath,
  groupsPath,
  surveyPath,
  trackingPath,
} from '../../utils/paths';

export default {
  getUserList: (filters) => {
    if (shouldUseMock()) {
      return getUserListMock();
    }
    return apiCall(
      `${baseUrl}${authPath}tutor/users/list${parseQueryParams(filters)}`,
      'GET'
    );
  },
  userStatsGet: (user_id) => {
    if (shouldUseMock()) {
      return getUserStatsMock();
    }
    return apiCall(`${baseUrl}${authPath}user/${user_id}/profile`, 'GET');
  },
  getUserCourses: (filters) => {
    if (shouldUseMock()) {
      return getUserCoursesMock();
    }
    return apiCall(
      `${baseUrl}${coursePath}user/course/list${parseQueryParams(filters)}`,
      'GET'
    );
  },
  getUserGroups: (filters) => {
    if (shouldUseMock()) {
      return getUserGroupsMock();
    }
    return apiCall(
      `${baseUrl}${groupsPath}membership/groups/list${parseQueryParams(
        filters
      )}`,
      'GET'
    );
  },
  getCourseStats: (id) => {
    if (shouldUseMock()) {
      return getCourseStatsMock();
    }
    return apiCall(`${baseUrl}${coursePath}report/course/${id}/details`, 'GET');
  },
  getCourseActivities: (course_id, filters) => {
    if (shouldUseMock()) {
      return getCourseActivitiesMock();
    }
    return apiCall(
      `${baseUrl}${coursePath}report/course/${course_id}/activities${parseQueryParams(
        filters
      )}`,
      'GET'
    );
  },
  eventSessionsGet: (course_id, filters) => {
    if (shouldUseMock()) {
      return getCourseActivitiesMock();
    }
    return apiCall(
      `${baseUrl}${activitySessionPath}course/${course_id}/session/report${parseQueryParams(
        filters
      )}`,
      'GET'
    );
  },
  getCourseUsers: (course_id, filters) => {
    if (shouldUseMock()) {
      return getCourseUsersMock();
    }
    return apiCall(
      `${baseUrl}${coursePath}report/course/${course_id}/users${parseQueryParams(
        filters
      )}`,
      'GET'
    );
  },
  eventUsersGet: (course_id, filters) => {
    if (shouldUseMock()) {
      return getCourseUsersMock();
    }
    return apiCall(
      `${baseUrl}${activitySessionPath}course/${course_id}/session/users/report${parseQueryParams(
        filters
      )}`,
      'GET'
    );
  },
  getCourseUsersActivities: (course_id, user_id) => {
    if (shouldUseMock()) {
      return getCourseUsersActivitiesMock();
    }
    return apiCall(
      `${baseUrl}${coursePath}report/course/${course_id}/user/${user_id}/activities`,
      'GET'
    );
  },
  groupCoursesGet: (id, filters) => {
    if (shouldUseMock()) {
      return getGroupCoursesMock();
    }
    return apiCall(
      `${baseUrl}${groupsPath}group/courses/${id}/list${parseQueryParams(
        filters
      )}`,
      'GET'
    );
  },
  getMyCourses: (year) => {
    if (shouldUseMock()) {
      return getMyCoursesMock(year);
    }
    return apiCall(
      `${baseUrl}${coursePath}statistics/tutor/my_courses${parseQueryParams({
        year,
      })}`,
      'GET'
    );
  },
  getMyUsers: (filters, completion_status) => {
    if (shouldUseMock()) {
      return getMyUsersMock();
    }
    return apiCall(
      `${baseUrl}${coursePath}statistics/tutor/my_users${parseQueryParams({
        ...filters,
        completion_status,
      })}`,
      'GET'
    );
  },
  getCourseCreatedList: (filter) => {
    if (shouldUseMock()) {
      return getCourseCreatedListMock();
    }
    return apiCall(
      `${baseUrl}pzzl_course/course/created/list${parseQueryParams(filter)}`,
      'GET'
    );
  },
  surveyStatsGet: (id) => {
    if (shouldUseMock()) {
      return getSurveyStatsMock();
    }
    return apiCall(
      `${baseUrl}${surveyPath}course/${id}/survey/statistics`,
      'GET'
    );
  },
  surveyFreeTextAnswersGet: (courseId, filters) => {
    if (shouldUseMock()) {
      return getSurveyFreeTextMock();
    }
    return apiCall(
      `${baseUrl}${surveyPath}course/${courseId}/survey/free_text/list${parseQueryParams(
        filters
      )}`,
      'GET'
    );
  },
  //* csv
  csvChartExport: (filters) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return exportFileCall({
      url: `${baseUrl}${coursePath}statistics/tutor/my_graphics/download${parseQueryParams(
        filters
      )}`,
      method: 'GET',
      filename: `statistics_${filters?.filter}_${filters?.completion_status}.csv`,
    });
  },
  csvAccessExport: (filters) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return exportFileCall({
      url: `${baseUrl}${trackingPath}access/statistics/download${parseQueryParams(
        filters
      )}`,
      method: 'GET',
      filename: `access.csv`,
    });
  },
  csvMyTutorExport: () => {
    if (shouldUseMock()) {
      return successMock();
    }
    return exportFileCall({
      url: `${baseUrl}${trackingPath}tutor/statistics/download`,
      method: 'GET',
      filename: `tutors.csv`,
    });
  },
  csvCategoriesExport: (filters) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return exportFileCall({
      url: `${baseUrl}${trackingPath}category/statistics/download${parseQueryParams(
        filters
      )}`,
      method: 'GET',
      filename: `categories.csv`,
    });
  },
  csvCoursesExport: (filters) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return exportFileCall({
      url: `${baseUrl}${trackingPath}courses/statistics/download${parseQueryParams(
        filters
      )}`,
      method: 'GET',
      filename: `courses_${filters?.filter}.csv`,
    });
  },
  csvActivitiesExport: (filters) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return exportFileCall({
      url: `${baseUrl}${trackingPath}activity/statistics/download${parseQueryParams(
        filters
      )}`,
      method: 'GET',
      filename: `activities.csv`,
    });
  },
  //* others
  courseExport: (filters, title) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return exportFileCall({
      url: `${baseUrl}${coursePath}statistics/tutor/my_courses/download${parseQueryParams(
        filters
      )}`,
      method: 'GET',
      filename: `course_${title || filters?.course_id}_${
        filters?.export_type
      }.csv`,
    });
  },
  usersExport: (filters) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return exportFileCall({
      url: `${baseUrl}${coursePath}tutor/my_users/download${parseQueryParams(
        filters
      )}`,
      method: 'GET',
      filename: filters?.export_type ? `${filters?.export_type}.csv` : null,
    });
  },
  tutorsExport: (filters) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return exportFileCall({
      url: `${baseUrl}${trackingPath}tutor/download${parseQueryParams(
        filters
      )}`,
      method: 'GET',
      filename: 'tutors.csv',
    });
  },
  categoriesExport: (filters) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return exportFileCall({
      url: `${baseUrl}${trackingPath}category/download${parseQueryParams(
        filters
      )}`,
      method: 'GET',
      filename: 'aree_tematiche.csv',
    });
  },
  activitiesExport: (filters) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return exportFileCall({
      url: `${baseUrl}${trackingPath}activity/download${parseQueryParams(
        filters
      )}`,
      method: 'GET',
      filename: filters?.export_type ? `${filters?.export_type}.csv` : null,
    });
  },
};
